import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutEnjoyClComponent } from './layout/components/layout-enjoy-cl/layout-enjoy-cl.component';
import { Error404Component } from './shared/components/error404/error404.component';
import { DataGuard } from './shared/guard/data.guard';
import { UnidadGuard } from './shared/guard/unidad.guard';
import { SharedModule } from './shared/shared.module';
import { SEOResolve } from './services/seo.service';

const routes: Routes = [
  {
    path: '',
    component: LayoutEnjoyClComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: './modules/enjoy-cl/home-enjoycl/home-enjoycl.module#HomeEnjoyclModule',
        pathMatch: 'full',
        resolve: {
          seo: SEOResolve
        }
      },
      {
        path: 'espectaculos',
        loadChildren: './modules/enjoy-cl/espectaculo-enjoycl/espectaculo-enjoycl.module#EspectaculoEnjoyclModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        },
      },
      {
        path: 'promociones',
        loadChildren: './modules/enjoy-cl/promocion-enjoycl/promocion-enjoycl.module#PromocionEnjoyclModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'unidades',
        loadChildren: './modules/enjoy-cl/elije-enjoy/elije-enjoy.module#ElijeEnjoyModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'documentos-legales',
        loadChildren: './modules/enjoy-cl/doc-legales-enjoycl/doc-legales-enjoycl.module#DocLegalesEnjoyclModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'proveedores',
        loadChildren: './modules/enjoy-cl/proveedores-enjoycl/proveedores-enjoycl.module#ProveedoresEnjoyclModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'nosotros',
        loadChildren: './modules/enjoy-cl/nosotros-enjoycl/nosotros-enjoycl.module#NosotrosEnjoyclModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'centro-de-ayuda',
        loadChildren: './modules/enjoy-cl/centro-ayuda-enjoycl/centro-ayuda-enjoycl.module#CentroAyudaEnjoyclModule',
        resolve: {
          data: DataGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'dynamic-content/:contentId',
        loadChildren: './modules/enjoy-cl/dynamic-content/dynamic-content.module#DynamicContentModule',
        pathMatch: 'full',
        resolve: {
          seo: SEOResolve
        }
      },
      {
        path: 'dynamic-content/:contentId/:idIdioma',
        loadChildren: './modules/enjoy-cl/dynamic-content/dynamic-content.module#DynamicContentModule',
        pathMatch: 'full',
        resolve: {
          seo: SEOResolve
        }
      },
      {
        path: ':unidad',
        loadChildren: './modules/enjoy-cl/unidad/unidad.module#UnidadModule',
        resolve: {
          data: UnidadGuard,
          seo: SEOResolve
        }
      },
      {
        path: 'error/404',
        component: Error404Component,
        resolve: {
          seo: SEOResolve
        }
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'error/404',
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', useHash: true, preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload'  })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }
